import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { GetDevicesReply, HttpResponse } from '@/types/io';
import { Device } from '@/types/corev3';

export class ApiClient {

  private coreBaseURL: string = process.env.VUE_APP_INSTALL_API_BASE_URL;

  private baseConfig = {
    timeout: 20000,
    validateStatus: () => true,
    headers: {}
  };

  public async getDevices(payload:object): Promise<GetDevicesReply & HttpResponse> {

    const cfg = Object.assign({}, this.baseConfig, {
      method: 'get' as 'get',
      url: `${this.coreBaseURL}/devices`,
      params: Object.assign({}, payload),
    });

    const resp = await this.doRequest(cfg);

    return {httpCode: resp.httpCode, errorMsg: resp.errorMsg, deviceList: resp.data as Device[]};
  }

  private async doRequest(req: AxiosRequestConfig, expectedHttpCode?: number): Promise<HttpReply> {

    let resp: AxiosResponse;

    try {
      resp = await axios.request(req);
    } catch (err) {
      return {errorMsg: `${err}`};
    }

    // we expect a code 200 by default
    expectedHttpCode = expectedHttpCode !== undefined ? expectedHttpCode : 200;

    if (resp.status !== expectedHttpCode) {
      if (resp.data && resp.data.message) {
        return {httpCode: resp.status, errorMsg: `${resp.data.message} (HTTP ${resp.status})`};
      } else {
        return {httpCode: resp.status, errorMsg: `unexpected HTTP error ${resp.status}`};
      }
    }
    return Promise.resolve({httpCode: resp.status, data: resp.data});
  }
}


interface HttpReply {
  httpCode?: number;
  errorMsg?: string;
  data?: object;
}